// The pause state shared by the hero's scripted conversation and its look
// auto-advance: both count only active time, while the hero is on screen in a
// visible tab.

export type SceneClock = { paused: boolean; resumedAt: number };

/** Pauses or resumes the clock at `now`; a resume counts afresh from that moment. */
export function setScenePaused(clock: SceneClock, paused: boolean, now: number): void {
  if (clock.paused && !paused) clock.resumedAt = now;
  clock.paused = paused;
}

/**
 * Active milliseconds since the previous tick at `last`: none while paused and
 * none before the latest resume. A hidden tab's timers fire late (up to a
 * minute), so the first tick after the tab returns must not count the time it
 * was hidden.
 */
export function activeElapsed(clock: SceneClock, last: number, now: number): number {
  return clock.paused ? 0 : now - Math.max(last, clock.resumedAt);
}
